// extracted by mini-css-extract-plugin
module.exports = {"modal":"AccessDialog_modal__2XRnI","overlay":"AccessDialog_overlay__3_ZQq","blur":"AccessDialog_blur__17sya"};